import React from "react";

const Sponsors = () => {
  const platinumSponsors = [
    {
      name: "Avanti Feeds",
      logo: require("../assets/img/aqua-logos/Platinum/avanti_updated_logo.png"),
    },
    {
      name: "Growel",
      logo: require("../assets/img/aqua-logos/Platinum/Growel Blue Logo.png"),
    },
    {
      name: "NexGen",
      logo: require("../assets/img/aqua-logos/Platinum/nexgen.jpg"),
    },
    {
      name: "Vaisakhi Biomarine",
      logo: require("../assets/img/aqua-logos/Platinum/vaisakhi.jpg"),
    },
    {
      name: "Vaishnavi Aquatech",
      logo: require("../assets/img/aqua-logos/Platinum/Vaishnavi Aquateck PVT LTD LOGO.jpg"),
    },
  ];

  const goldSponsors = [
    {
      name: "ADM",
      logo: require("../assets/img/aqua-logos/Gold/ADM LOGO.jpg"),
    },
    {
      name: "Devi Sea Foods",
      logo: require("../assets/img/aqua-logos/Gold/Devi Sea Foods.png"),
    },
    {
      name: "Inve CFG",
      logo: require("../assets/img/aqua-logos/Gold/inve_cfg.png"),
    },
    {
      name: "I & V Bio",
      logo: require("../assets/img/aqua-logos/Gold/I & V Bio.jpg"),
    },
    {
      name: "Kemin Aquascience",
      logo: require("../assets/img/aqua-logos/Gold/Kemin Logo_Full Color_2023.png"),
    },
    {
      name: "Poseidon Biotech",
      logo: require("../assets/img/aqua-logos/Gold/Poseidon AI 2026 Logo.jpg"),
    },
    {
      name: "Qrill Aqua",
      logo: require("../assets/img/aqua-logos/Gold/QRILL AQUA_AQC.jpg"),
    },
    {
      name: "Sapthagiri Hatcheries",
      logo: require("../assets/img/aqua-logos/Platinum/Sapthagiri Hatcheries.jpg"),
    },
     {
      name: "Syaqua",
      logo: require("../assets/img/aqua-logos/Gold/syaqua.jpg"),
    },
  ];

  const silverSponsors = [
    {
      name: "Adisseo",
      logo: require("../assets/img/aqua-logos/Silver/Adisseo_Logo_og.png"),
    },
    {
      name: "Bentoli",
      logo: require("../assets/img/aqua-logos/Silver/Bentoli Blue Font (1) (3).png"),
    },
    {
      name: "Deevee Biologicals",
      logo: require("../assets/img/aqua-logos/Silver/DEVEE GROUP 20 YEARS LOGO.jpg"),
    },
    {
      name: "Finray Biotech",
      logo: require("../assets/img/aqua-logos/Silver/FINRAY BIOTECH PRIVATE LIMITED.png"),
    },
    {
      name: "MM Bioscience",
      logo: require("../assets/img/aqua-logos/Silver/MM BioScience.jpeg"),
    },
    {
      name: "Nurture Aqua Technology",
      logo: require("../assets/img/aqua-logos/Silver/Nurture Aqua Technology Logo (1).png"),
    },
    {
      name: "Phileo by Lasaffre",
      logo: require("../assets/img/aqua-logos/Silver/Phileo.png"),
    },
    {
      name: "Salem Microbes",
      logo: require("../assets/img/aqua-logos/Silver/Salem Microbes Meet.jpg"),
    },
    {
      name: "Sanzyme Biologics",
      logo: require("../assets/img/aqua-logos/Silver/Sanzyme.jpg"),
    },
    {
      name: "Shenglong Biotech",
      logo: require("../assets/img/aqua-logos/Silver/Shenglong Logo & Slogan.jpg"),
    },
    {
      name: "Tata Rallis",
      logo: require("../assets/img/aqua-logos/Silver/Rallis.png"),
    },
    {
      name: "UniBio India",
      logo: require("../assets/img/aqua-logos/Silver/UniBio India_Logo (hi-res).png"),
    },
  ];

  // --- NEW: Added Media Partners Array ---
  const mediaPartners = [
    {
      name: "Media Partner 1",
      // REPLACE with your actual image path
      logo: require("../assets/img/media-partner/1.png"),
    },
    {
      name: "Media Partner 2",
      // REPLACE with your actual image path
      logo: require("../assets/img/media-partner/2.png"),
    },
  ];

  const renderLogo = (logo, name) => {
    return (
      <img src={logo} alt={name} className="w-full h-full object-contain" />
    );
  };

  return (
    <div className="w-full max-w-6xl mx-auto px-4 py-20">
      {/* PLATINUM SPONSORS */}
      <section className="mb-16">
        <h2 className="md:text-3xl text-xl font-bold text-center text-red mb-8">
          PLATINUM SPONSORS
        </h2>

        <div className="flex flex-wrap justify-center gap-x-10 gap-y-10 max-w-4xl mx-auto">
          {platinumSponsors.map(({ name, logo }, index) => (
            <div
              key={index}
              className="md:w-56 w-32 md:h-44 flex items-end justify-center p-1 md:p-4"
            >
              <img
                src={logo}
                alt={name}
                className="object-contain max-h-full max-w-full"
              />
            </div>
          ))}
        </div>
      </section>

      {/* GOLD SPONSORS */}
      <section className="mb-16">
        <h2 className="md:text-3xl text-xl font-bold text-center text-red mb-8">
          GOLD SPONSORS
        </h2>
        <div className="flex flex-wrap justify-center gap-6 max-w-6xl mx-auto">
          {goldSponsors.map(({ name, logo }, index) => (
            <div
              key={index}
              className="md:w-[20%] max-w-[12rem] w-16 md:h-32 flex items-center justify-center md:p-4"
            >
              <div className="w-full h-full">{renderLogo(logo, name)}</div>
            </div>
          ))}
        </div>
      </section>

      {/* SILVER SPONSORS */}
      {/* Added mb-16 here to create space before the new Media Partners section */}
      <section className="mb-16">
        <h2 className="md:text-3xl text-xl font-bold text-center text-red mb-8">
          SILVER SPONSORS
        </h2>
        <div className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto">
          {silverSponsors.map(({ name, logo }, index) => (
            <div
              key={index}
              className="md:w-[22%] max-w-[10rem] w-16 md:h-20 h-10 flex items-center justify-center md:p-2"
            >
              <div className="w-full h-full">{renderLogo(logo, name)}</div>
            </div>
          ))}
        </div>
      </section>

      {/* --- NEW SECTION: MEDIA PARTNERS --- */}
      <section>
        <h2 className="md:text-3xl text-xl font-bold text-center text-red mb-8">
          MEDIA PARTNERS
        </h2>
        <div className="flex flex-wrap justify-center gap-8 max-w-3xl mx-auto">
          {mediaPartners.map(({ name, logo }, index) => (
            <div
              key={index}
              // Sizing: Slightly larger than Silver, responsive flex
              className="w-32 md:w-48 h-20 md:h-32 flex items-center justify-center p-2"
            >
              <div className="w-full h-full">{renderLogo(logo, name)}</div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Sponsors;
